import { render, staticRenderFns } from "./grouponWeapp.vue?vue&type=template&id=7f5a5994&scoped=true"
import script from "./grouponWeapp.vue?vue&type=script&lang=js"
export * from "./grouponWeapp.vue?vue&type=script&lang=js"
import style0 from "./grouponWeapp.vue?vue&type=style&index=0&id=7f5a5994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a5994",
  null
  
)

component.options.__file = "grouponWeapp.vue"
export default component.exports